import api from './api'

export interface CompanyProfile {
  id: string
  company_name: string
  legal_name?: string
  tagline?: string
  website?: string
  email?: string
  support_email?: string
  phone?: string
  whatsapp_number?: string
  address_line1?: string
  address_line2?: string
  city?: string
  state?: string
  state_code?: string
  pincode?: string
  country?: string
  gstin?: string
  pan?: string
  cin?: string
  logo_url?: string
  dark_logo_url?: string
  favicon_url?: string
  signature_url?: string
  stamp_url?: string
  primary_color?: string
  secondary_color?: string
  accent_color?: string
  bank_name?: string
  bank_account_holder?: string
  bank_account_number?: string
  bank_ifsc?: string
  bank_branch?: string
  upi_id?: string
  invoice_header_note?: string
  invoice_footer_note?: string
  terms_and_conditions?: string
  extra_settings?: Record<string, any>
  incomplete_fields?: string[]
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export type BrandingAssetKind = 'logo' | 'dark_logo' | 'signature' | 'stamp' | 'favicon'
export type PreviewKind =
  | 'invoice' | 'estimate' | 'sales_order' | 'delivery_challan' | 'sales_return'
  | 'purchase_order' | 'purchase_bill' | 'ledger' | 'catalogue' | 'price_list'

export const companyProfileService = {
  getProfile: async (): Promise<CompanyProfile> => {
    const response = await api.get<CompanyProfile>('/admin/company-profile')
    return response.data
  },

  updateProfile: async (payload: Partial<CompanyProfile>): Promise<CompanyProfile> => {
    const response = await api.put<CompanyProfile>('/admin/company-profile', payload)
    return response.data
  },

  uploadAsset: async (kind: BrandingAssetKind, file: File): Promise<{ kind: string; url: string; size: number }> => {
    const form = new FormData()
    form.append('kind', kind)
    form.append('file', file)
    const response = await api.post('/admin/company-profile/assets', form, { headers: { 'Content-Type': 'multipart/form-data' } })
    return response.data
  },

  // Returns a blob URL for a sample PDF rendered with the saved branding and template settings.
  previewPdf: async (kind: PreviewKind, printerFormat: string = 'tally_prime'): Promise<string> => {
    const response = await api.get(`/admin/company-profile/preview/${kind}`, {
      params: { printer_format: printerFormat },
      responseType: 'blob',
    })
    return URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
  },

  getPublicProfile: async (): Promise<Partial<CompanyProfile>> => {
    const response = await api.get<Partial<CompanyProfile>>('/public/company-profile')
    return response.data
  }
}
